import * as types from './types';

export const setLoginOffline = value => {
  return {
    type: types.LOGIN_SET_LOGIN_OFFLINE,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/login/state/login/actions.js